import HttpStatus from "http-status-codes";
import type { NextApiResponse } from "next";
import { config } from "~/config";
import type { AppContext } from "~/lib/context";
import { FiguresBaseError } from "~/lib/errors/figuresBaseError";
import { logError } from "~/lib/logger";
import { ErrorCode, makeErrorPayload } from "~/lib/makeErrorPayload";

export class SsoUserProvisioningMissingEmployeeRecordError extends FiguresBaseError {
  constructor() {
    super("Could not map SAML Profile to an existing employee record");
    Object.setPrototypeOf(this, SsoUserProvisioningMissingEmployeeRecordError.prototype);
  }
}

export const handleSsoUserProvisioningMissingEmployeeRecordError = (
  ctx: AppContext,
  res: NextApiResponse,
  error: SsoUserProvisioningMissingEmployeeRecordError
) => {
  logError(ctx, "[error] SSO user provisioning missing employee record", { error });

  if (config.app.isJest) {
    // eslint-disable-next-line no-console
    console.error(error);
  }

  res.redirect("/error/sso-user-provisioning-missing-employee-record");
  res
    .status(HttpStatus.BAD_REQUEST)
    .json(makeErrorPayload({ error, defaultCode: ErrorCode.SSO_USER_PROVISIONING_MISSING_EMPLOYEE_RECORD }));
};
